{
  "LoadingLabel": "[Carregando...]",
  "NAME": "ComboBox"
}